export { SegmentedControl, SegmentedControlButton } from "./segmented-control"
export type {
  SegmentedControlButtonProps,
  SegmentedControlItem,
  SegmentedControlProps,
} from "./segmented-control"
